import { 
    REMOVE_USER,
    SET_CONFIGURATION,
    SET_FRONT_PAGE,
    SET_USER,
    UPDATE_EDITIONS,
    UPDATE_SHOW_TOOLTIP,
    PUSH_NOTIFICATION,
    POP_NOTIFICATION
} from './types'
import { authenticated, graphqlFetch } from '../../components/cdl-react-components/utilities'
import { deleteCookie, logEvent } from '../../utilities'

export const setUser = () => {
    return async dispatch => {
        const response = await graphqlFetch('auth', `
            query {
                user {
                    firstName
                    lastName
                    email
                    username
                    isCDLUser
                }
            }`)
        
        authenticated('CDD')
            .then((authed) => {
                dispatch({ 
                    type: SET_USER, 
                    payload: { 
                        user: (response.data &&
                            response.data.user) || 
                            undefined,
                        authenticated: authed
                    }
                })
            })
    }
}

export const removeUser = () => {
    return dispatch => {
        graphqlFetch('auth', `
            mutation {
                logout
            }`)
            .then(() => {
                dispatch({ type: REMOVE_USER })
                deleteCookie('AuthCookie')
                deleteCookie('SqlAuthCookie')
                deleteCookie('WsLogKey')
                window.location.href = '/'
            })
    }
}

export const updateEditions = editions => {
    return dispatch => {
        logEvent({ 'New_Editions': editions.length })
        dispatch({ type: UPDATE_EDITIONS, payload: editions })
    }
}

export const setConfigurationLoginModalOpen = loginModalOpen => {
    if (loginModalOpen) {
        const username = document.querySelector('#username')
        username && username.focus()
    }
    return setConfiguration({ loginModalOpen })
}
export const setConfiguration = configuration => {
    return dispatch => dispatch({ type: SET_CONFIGURATION, payload: configuration })
}

export const setFrontPage = frontPage => {
    return dispatch => dispatch({ type: SET_FRONT_PAGE, payload: frontPage })
}

export const updateShowTooltip = showTooltip => {
    return dispatch => dispatch({ type: UPDATE_SHOW_TOOLTIP, payload: showTooltip })
}

export const pushNotification = (message, callback = undefined) => 
    dispatch => dispatch({ type: PUSH_NOTIFICATION, payload: { message, callback } })

export const popNotification = () =>  
    dispatch => dispatch({ type: POP_NOTIFICATION })
